import Layout from '../../../Layout';
import Photos from './photos';

import * as S from './styles';
import useScrollToTop from '../../../../utils/useScrollToTop';

function InteractionswithTijucaNationalPark() {
  useScrollToTop();

  return (
    <Layout>
      <h2>Interações com o Parque Nacional da Tijuca</h2>

      {/* <Photos /> */}

    </Layout>
  );
}

export default InteractionswithTijucaNationalPark;
